import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";

import * as firebase from "firebase";

export default action$ =>
  action$.ofType(Types.DELETE_QUEUE_ITEM).mergeMap(action =>
    firebase
      .database()
      .ref(`queues/${action.location}/${action.registrationId}`)
      .remove()
      .then(() => Creators.actionSucceeded())
      // FIXME: handle error case using showMessage as in customer module?
      .catch(() => Creators.actionSucceeded())
  );



// WEBPACK FOOTER //
// ./src/staff/epics/deleteQueueItem.js